const mutations = {
  mutationCustomers(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.customers[payload.tab] = payload.responseData;
    } else {
      state.customers = payload;
    }
  },

  mutationCustomersMeta(state, payload) {
    state.customersMeta = payload;
  },

  mutationCustomer(state, payload) {
    state.customer = payload;
  },

  mutationCustomerMeta(state, payload) {
    state.customerMeta = payload;
  },

  mutationStatuses(state, payload) {
    state.statuses = payload;
  },
};

export default mutations;
